import React, { FC, FormEvent, ChangeEvent, Dispatch, SetStateAction, useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
// import Lottie from 'react-lottie'
import { useIntl } from 'react-intl'

import LoginForm from './LoginForm'
import Walkin from './Walkin'
import Googler from './Googler'
// import Google from './Google'
import '../../../styles/homeTransition.scss'

import Countdown from '../Countdown'
import { icons } from '../../../lib/icons'
// import { localeContext, LocaleProps } from '../../../index'
// import { LandingPageImages } from '../../../utils/links'
// import { LottieJSON } from '../../../utils/links'

export type FormProps = {
    handleSubmit(e: FormEvent<HTMLFormElement>, eventId: string, channelId: string): void
    eventOpen: boolean
    code: string
    HandleInputChange(e: ChangeEvent<HTMLInputElement>): void
    eventSlug: string
    googler: boolean
}

export type LoginFormProps = FormProps & { eventId: string; channelId: string; style?: string; data:any }

interface HomeProps extends FormProps {
    walkinName: string
    walkinCompany: string
    walkinEmail: string
    auth: boolean
    handleWalkinSubmit(e: FormEvent<HTMLFormElement>): void
    handleGooglerSubmit(e: FormEvent<HTMLFormElement>): void
    setWalkinName: Dispatch<SetStateAction<string>>
    setWalkinCompany: Dispatch<SetStateAction<string>>
    setWalkinEmail: Dispatch<SetStateAction<string>>
    setGooglerName: Dispatch<SetStateAction<string>>
    googlerName: string
    eventState: string
    data: any
}

const Home: FC<HomeProps> = ({
    handleSubmit,
    eventOpen,
    code,
    HandleInputChange,
    eventSlug,
    setWalkinName,
    setWalkinCompany,
    setGooglerName,
    googlerName,
    handleWalkinSubmit,
    handleGooglerSubmit,
    walkinName,
    walkinCompany,
    walkinEmail,
    setWalkinEmail,
    googler,
    eventState,
    data,
}) => {
    // const [eventTime, setEventTime] = useState('')
    // const [isoStartTime, setIsoStartTime] = useState('')
    // const [isoEndTime, setIsoEndTime] = useState('')
    const [formattedDate, setFormattedDate] = useState('')
    const [startEndOpenTime, setStartEndOpenTime] = useState('')
    const [googleCalendarLink, setGoogleCalendarLink] = useState('')
    const [icsCalendarLink, setIcsCalendarLink] = useState('')
    const [configInfo, setConfigInfo] = useState<Record<string, string>>({});
    const intl = useIntl()

    // const { jsonData } = useContext(localeContext) as LocaleProps

    /**
     * 加入排程起始及結束時間
     */
    // useEffect(() => {
    //     const et = jsonData[`${eventSlug}.Event Time`]
    //     const ist = jsonData[`${eventSlug}.isoStartTime`]
    //     const iet = jsonData[`${eventSlug}.isoEndTime`]

    //     setEventTime(et)
    //     setIsoStartTime(ist)
    //     setIsoEndTime(iet)
    // }, [eventSlug])

        /**
     * 取得活動時間 data 並格式化
     */
        useEffect(() => {
            if (data) {

                console.log(data)

                const openDateTime = new Date(data[0].attributes.openTime);
                const startDateTime = new Date(data[0].attributes.startTime);
                const endDateTime = new Date(data[0].attributes.endTime);
    
                const year = startDateTime.getFullYear(); // 取得年份
                const month = startDateTime.getMonth() + 1; // 取得月份，注意 JavaScript 的月份是從 0 開始計算，所以要加上 1
                const date = startDateTime.getDate(); // 取得日期
                const dayOfWeek = startDateTime.toLocaleString('zh-CN', { weekday: 'short' }); // 取得星期
    
                const openHH = openDateTime.getHours().toString().padStart(2, '0'); // 取得小時
                const openMM = openDateTime.getUTCMinutes().toString().padStart(2, '0'); // 取得分鐘
                const startHH = startDateTime.getHours().toString().padStart(2, '0'); // 取得小時
                const startMM = startDateTime.getUTCMinutes().toString().padStart(2, '0'); // 取得分鐘
                const endHH = endDateTime.getHours().toString().padStart(2, '0'); // 取得小時
                const endMM = endDateTime.getUTCMinutes().toString().padStart(2, '0'); // 取得分鐘
    
                setStartEndOpenTime(`${startHH}:${startMM} - ${endHH}:${endMM} (${openHH}:${openMM} 开放入场)`); // 格式化日期，例如：2023 年 4 月 15 日 (週三)
                setFormattedDate(`${year} 年 ${month} 月 ${date} 日 (${dayOfWeek})`); // 格式化日期，例如：2023 年 4 月 15 日 (週三)


                const configInfo = data[0].attributes.landing_config
                setConfigInfo(configInfo)
                console.log(configInfo)
            }
        }, [data])
    
    /**
     * 從 strapi 拿取資料生成 calendar url
     */
    useEffect(() => {
        getCalendarLink()
    }, [data])
    
    const getCalendarLink = () => {
        if(data){
            const subject = encodeURIComponent(data[0].attributes.calendarSubject);
            const encodeIntro = encodeURIComponent(data[0].attributes.calendarBody);
            const introGoogle = encodeIntro.replace(/%0A/g, "%3Cbr%3E");
            const introIcs = encodeIntro.replace(/%0A/g, "%5Cn");
            const calStart = new Date(data[0].attributes.startTime).toISOString().replace(/-|:|\.\d+/g, "");
            const calEnd = new Date(data[0].attributes.endTime).toISOString().replace(/-|:|\.\d+/g, "");
            const dates = encodeURIComponent(calStart + '/' + calEnd);
    
            const googleCalendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${dates}&details=${introGoogle}&location=Online&text=${subject}`;
            setGoogleCalendarLink(googleCalendarLink);
            // console.log("googleCalendarLink:", googleCalendarLink);
            
            const icsCalendarLink = `data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0ADTSTART:${calStart}%0ADTEND:${calEnd}%0ASUMMARY:${subject}%0ADESCRIPTION:${introIcs}%0AEND:VEVENT%0AEND:VCALENDAR%0A`
            setIcsCalendarLink(icsCalendarLink);
            // console.log("icsCalendarLink:", icsCalendarLink);
        };
    }
    return (
<div className="landing-page-home-background" id="home" style={{ backgroundImage: `url(${data && data[0]?.attributes?.landing_config?.img_bg0 || ''})`}}>
            <div className="landing-page-home-wrap">
                <div className="landing-page-home-content">
                    <div className="landing-page-home-title">
                        <div className="landing-page-home-title-box">
                            <div className="landing-page-home-title-content">
                                {intl.formatMessage({ id: 'landingPage.event_title_1' })}
                            </div>
                        </div>
                    </div>

                

                    {data && (
                        <div className="landing-page-login-content-top">
                            <time className="landing-page-home-time">
                                <div className="landing-page-home-time-date">
                                {formattedDate}
                                </div>
                                <div className="landing-page-home-time-time">
                                {startEndOpenTime}
                                </div>
                            </time>

                            {eventState === 'countdown' ? (
                                <label className="landing-page-home-add-to-calendar-dropdown">
                                    <div className="dd-button">
                                        <div className="calendarIconBox">{icons.bell()}</div>
                                        {intl.formatMessage({ id: 'landingPage.calendar_btn' })}
                                    </div>
                                    <input type="checkbox" className="dd-input" id="test" />
                                    <ul className="dd-menu">
                                        <li>
                                            {googleCalendarLink && 
                                                <a target="_blank" href={googleCalendarLink} rel="noreferrer">
                                                    {intl.formatMessage({ id: 'landingPage.calendar_btn_google' })}
                                                </a>
                                            }
                                        </li>
                                        <li>
                                            {icsCalendarLink &&
                                                <a target="_blank" href={icsCalendarLink} rel="noreferrer" download={eventSlug}>
                                                    {intl.formatMessage({ id: 'landingPage.calendar_btn_ics' })}
                                                </a>
                                            }
                                        </li>
                                    </ul>
                                </label> ) : null
                            }
                        </div>
                    )}
                    <div className="landing-page-kv">
                    {configInfo && configInfo.img_kv && <img src={configInfo.img_kv} alt="" />}
  
                    </div>
                    <Countdown 
                        eventState={eventState} 
                        data={data}
                        classes={'landing-page-count-down'} />
                    <Routes>
                        <Route
                            path="/:id"
                            element={
                                <>
                                   {data && (
                                        <LoginForm
                                            handleSubmit={handleSubmit}
                                            eventOpen={eventOpen}
                                            code={code}
                                            HandleInputChange={HandleInputChange}
                                            eventSlug={eventSlug}
                                            googler={googler}
                                            eventId={eventSlug}
                                            channelId={data[0].attributes.channelId}
                                            data={data}
                                        />
                                    )}
                                </>
                            }
                        />
                        <Route
                            path="/walkin/:id"
                            element={
                                <Walkin
                                    setWalkinName={setWalkinName}
                                    setWalkinCompany={setWalkinCompany}
                                    handleWalkinSubmit={handleWalkinSubmit}
                                    walkinName={walkinName}
                                    walkinCompany={walkinCompany}
                                    walkinEmail={walkinEmail}
                                    setWalkinEmail={setWalkinEmail}
                                />
                            }
                        />
                        <Route
                            path="/g/:id"
                            element={
                                <>
                                {data &&(
                                    <Googler
                                    handleGooglerSubmit={handleGooglerSubmit}
                                    setGooglerName={setGooglerName}
                                    googlerName={googlerName}
                                    data={data}
                                />
                                )}
                                </>
                            }
                        />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default Home
